// Import react elements
import React, { useState, useEffect } from "react";

// Import hooks
import { usePersistentFilters } from "global/hooks/usePersistentFilters";

// Import components
import CustomisableTable from "global/components/CustomisableTable";
import CreateToggleFilters from "global/components/CreateToggleFilters";




const PayoutsTable = ({ initialTableColumns, payoutsData, loadingPayouts, uniqueFilterOptions, defaultFilters, handleRowSingleClick }) => {
  
    // Set boolean state for displaying quick checkbox filters
    const [toggleTableQuickFilters, setToggleQuickFilters] = useState(false);

    // Set filters state - needs passing to filters component and table component
    const [filters, setFilters] = useState({});

    // State needed for row selection
    const [selectedRows, setSelectedRows] = useState([]);

    // Your filter keys you want to persist
    const filterKeys = ["payoutMethod", "payoutStatus"];

    // This object maps internal filter keys to user-friendly labels
    const filterLabels = {
        method: "Method",
        status: "Status",
    };

    // Extract form-related state and functions from the `usePersistentFilters` custom hook
    const {
        selectedFilters,
        toggleFilterValue,
        setFilterGroupAllOn,
        setFilterGroupAllOff,
        resetFilterGroup
    } = usePersistentFilters("payoutsTable", filterKeys, defaultFilters);


    useEffect(() => {

        setFilters((prev) => ({
            ...prev,
            ...selectedFilters,
        }));

    }, [selectedFilters]);


    // Check if any checkbox filters have been selected - so we can change the collapse/expand icon colour
    const anyFiltersSelected = Object.values(selectedFilters).some((selectedFilter) => selectedFilter.length > 0);


    // Handle single click on a payout row
    const handleSelectPayout = (rowid) => {

        if (handleRowSingleClick) handleRowSingleClick(rowid);

    };


    return (

        <div style={{ overflowX: "auto", minWidth: "100%" }}>


            <div className={"quick_filters_and_table " + ((Object.keys(uniqueFilterOptions).length > 0) ? "display-filters" : "hidden-filters")}>

                {(Object.keys(uniqueFilterOptions).length > 0) &&

                    <div className={"collapsable_quick_filters " + (toggleTableQuickFilters ? "table__quick_filters--open" : "table__quick_filters--closed")}>

                        {!toggleTableQuickFilters && (Object.keys(uniqueFilterOptions).length > 0) &&

                        <div className="collapse_quick_filters_button_banner" onClick={() => { setToggleQuickFilters((prev) => !prev) }}>

                            <button
                                title={toggleTableQuickFilters ? "Hide Quick Filters" : "Show Quick Filters"}
                                className={"collapse_quick_filters_button " + (anyFiltersSelected ? "highlight_quick_filters_icon" : "") }
                            >

                                {toggleTableQuickFilters ? "❮" : "🝖"}
                            
                            </button> 

                        </div>
                        }
         
                        {toggleTableQuickFilters &&

                            <div className="filter_groups">

                                <button
                                    onClick={() => { setToggleQuickFilters((prev) => !prev) }}
                                    title={"Hide Quick Filters"}
                                    className={"collapse_quick_filters_button collapse_quick_filters_button--hide " + (anyFiltersSelected ? "highlight_quick_filters_icon" : "") }
                                >

                                    ❮
                                
                                </button> 

                                <div className="left_checkbox_filters_div">

                                    <CreateToggleFilters
                                        uniqueFilterOptions={uniqueFilterOptions}
                                        selectedFilters={selectedFilters}
                                        defaultFilters={defaultFilters}
                                        filterLabels={filterLabels}
                                        toggleFilterValue={toggleFilterValue}
                                        setFilterGroupAllOn={setFilterGroupAllOn}
                                        setFilterGroupAllOff={setFilterGroupAllOff}
                                        resetFilterGroup={resetFilterGroup}
                                        setSelectedRows={setSelectedRows}
                                    />

                                </div>

                            </div>

                        }

                    </div>

                }


                <div className="right_table_div">

                    <CustomisableTable
                        tableData={payoutsData}
                        initialTableColumns={initialTableColumns}
                        loadingData={loadingPayouts}
                        handleSelectRow={handleSelectPayout}
                        handleRowSingleClick={handleSelectPayout}
                        filterKeys={filterKeys}
                        filters={filters}
                        setFilters={setFilters}
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                    />

                </div>
            
           </div>

        </div>

    )

};

export default PayoutsTable;